import ScrollReveal from 'scrollreveal';

export default {
  init() {
    // Home page: scroll reveal runs in finalize() after DOM is ready.
  },

  finalize() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const sr = ScrollReveal({
      distance: '32px',
      duration: 750,
      easing: 'cubic-bezier(0.5, 0, 0, 1)',
      reset: false,
      viewFactor: 0.12,
    });

    const srHero = ScrollReveal({
      distance: '28px',
      duration: 700,
      easing: 'cubic-bezier(0.5, 0, 0, 1)',
      reset: false,
      viewFactor: 0.08,
    });

    /** Delay between paired elements (service images, why-choose iframes, etc.) */
    const staggerMs = 200;

    // --- Top hero (desktop XL) ---
    const topHero = 'section.hero-figma-section:not(.footer-hero)';
    srHero.reveal(`${topHero} .hero-figma__content`, { origin: 'left', delay: 80, viewFactor: 0.05 });
    srHero.reveal(`${topHero} .hero-figma__title-line`, { origin: 'top', delay: 140 });
    srHero.reveal(`${topHero} .hero-figma__desc`, { origin: 'top', delay: 220 });
    srHero.reveal(`${topHero} .hero-figma__actions .btn`, { origin: 'bottom', delay: 280, interval: 90 });
    srHero.reveal(`${topHero} .strapline`, { origin: 'bottom', delay: 120, viewFactor: 0.05 });

    // --- Top hero (mobile) — sibling directly after main hero section ---
    const topMobile = 'section.hero-figma-section:not(.footer-hero) + .mobile-hero';
    sr.reveal(`${topMobile} .value-1`, { origin: 'top', delay: 100, viewFactor: 0 });
    sr.reveal(`${topMobile} .value-2`, { origin: 'top', delay: 180, viewFactor: 0 });
    sr.reveal(`${topMobile} .value-3`, { origin: 'top', delay: 220, viewFactor: 0 });
    sr.reveal(`${topMobile} .hero-figma__actions .btn`, { origin: 'bottom', delay: 260, viewFactor: 0, interval: 80 });
    sr.reveal(`${topMobile} .strapline-small`, { origin: 'bottom', delay: 140, viewFactor: 0 });

    // --- Testimonials ---
    sr.reveal('.home-section--testimonials .section-head', { origin: 'top', delay: 80 });
    sr.reveal('.home-section--testimonials .testimonials-panel__col--media', { origin: 'left', delay: 120 });
    sr.reveal('.home-section--testimonials .testimonials-panel__col--content', { origin: 'right', delay: 140 });
    sr.reveal('.home-section--testimonials .testimonials-carousel', { origin: 'bottom', delay: 200 });
    sr.reveal('.home-section--testimonials .slider-nav', { origin: 'bottom', delay: 260 });

    // --- Service panels (per block; image side follows row layout) ---
    sr.reveal('.home-section--services .section-service .section-head', { origin: 'top', delay: 80, interval: 100 });
    // Stagger .one then .two inside each service block (same origin as row image side)
    document.querySelectorAll('.home-section--services .section-service').forEach((section) => {
      const row = section.querySelector('.section-service__row');
      const isLeft = row && row.classList.contains('section-service__row--image-left');
      const origin = isLeft ? 'left' : 'right';
      const imgOne = section.querySelector('.section-service__image.one');
      const imgTwo = section.querySelector('.section-service__image.two');
      if (imgOne) {
        sr.reveal(imgOne, { origin, delay: 100 });
      }
      if (imgTwo) {
        sr.reveal(imgTwo, { origin, delay: 100 + staggerMs });
      }
    });
    sr.reveal('.home-section--services .section-service__row--image-left .section-service__content', { origin: 'right', delay: 120 });
    sr.reveal('.home-section--services .section-service__row--image-right .section-service__content', { origin: 'left', delay: 120 });
    sr.reveal('.home-section--services .section-service .btn', { origin: 'bottom', delay: 160, interval: 80 });

    // --- Why choose ---
    sr.reveal('.home-section--why-choose .section-head', { origin: 'top', delay: 80 });
    sr.reveal('.home-section--why-choose .card-feature', { origin: 'bottom', interval: 120 });
    document.querySelectorAll('.home-section--why-choose .why-choose-videos').forEach((videosCol) => {
      const baseDelay = 100;
      videosCol.querySelectorAll('iframe').forEach((iframe, index) => {
        sr.reveal(iframe, { origin: 'right', delay: baseDelay + index * staggerMs });
      });
    });
    sr.reveal('.home-section--why-choose .cta .btn', { origin: 'bottom', delay: 220 });

    // --- Gallery ---
    sr.reveal('.home-section--gallery .section-head', { origin: 'top', delay: 80 });
    sr.reveal('.home-section--gallery .gallery-col', { origin: 'bottom', interval: 60, delay: 100 });
    sr.reveal('.home-section--gallery .section-cta', { origin: 'bottom', delay: 120 });

    // --- FAQ ---
    sr.reveal('.home-section--faq .faq-title', { origin: 'top', delay: 80 });
    sr.reveal('.home-section--faq .accordion-item', { origin: 'bottom', interval: 70 });
    sr.reveal('.home-section--faq .btn-primary', { origin: 'bottom', delay: 160 });

    // --- Footer hero (desktop) ---
    const footHero = 'section.footer-hero.hero-figma-section';
    srHero.reveal(`${footHero} .hero-figma__content`, { origin: 'left', delay: 80 });
    srHero.reveal(`${footHero} .hero-figma__title-line`, { origin: 'top', delay: 140 });
    srHero.reveal(`${footHero} .hero-figma__desc`, { origin: 'top', delay: 200 });
    srHero.reveal(`${footHero} .hero-figma__actions .btn`, { origin: 'bottom', delay: 260, interval: 90 });

    // --- Footer hero (mobile) ---
    const footMobile = 'section.footer-hero + .mobile-hero';
    sr.reveal(`${footMobile} .value-1`, { origin: 'top', delay: 80, viewFactor: 0 });
    sr.reveal(`${footMobile} .value-2`, { origin: 'top', delay: 140, viewFactor: 0 });
    sr.reveal(`${footMobile} .value-3`, { origin: 'top', delay: 180, viewFactor: 0 });
    sr.reveal(`${footMobile} .hero-figma__actions .btn`, { origin: 'bottom', delay: 220, viewFactor: 0 });
  },
};
